var map = {
	"./announcements.coffee": 261,
	"./autocomplete.coffee": 262,
	"./be.coffee": 263,
	"./bootstrap.coffee": 264,
	"./clients.coffee": 265,
	"./clock.coffee": 266,
	"./documents.coffee": 267,
	"./hello_coffee.coffee": 268,
	"./orders.coffee": 269,
	"./orders_fill_by_email.coffee": 270,
	"./packages.coffee": 271,
	"./product_sets.coffee": 272,
	"./products.coffee": 273,
	"./services.coffee": 274,
	"./sources.coffee": 275,
	"./statistics.coffee": 276,
	"./wallet_items.coffee": 277,
	"./warehouses.coffee": 278
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;